import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function deleteUtteranceFlag(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.patch("api/removeUtteranceFlagsSelected", {
      ...requestData,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
